import {
    Component,
    Input,
    OnInit
} from '@angular/core';
import { IDatiqGraph } from '@dat/datiq-components-pkg/graph';
import { isEqual } from 'lodash';
import { IDatiqGraphCardChart } from './models';
import {
    DatiqGraphCardChartMapperService,
    DatiqGraphCardChartService,
} from './services';

@Component({
    selector: 'datiq-graph-card-chart',
    templateUrl: './datiq-graph-card-chart.component.html',
    styleUrls: ['./datiq-graph-card-chart.component.scss'],
})
export class DatiqLaneCardChartComponent implements OnInit {
    public graph: IDatiqGraph;
    private _settings: IDatiqGraphCardChart;
    @Input()
    get settings(): IDatiqGraphCardChart {
        return this._settings;
    }
    set settings(_settings: IDatiqGraphCardChart) {
        if (isEqual(_settings, this._settings)) return;

        this._settings = { ..._settings };
        this.update();
    }
    public isPositive = false;
    public isNegative = false;
    public label = '';
    public labelIcon = '';
    public id = `lane-card-chart-${Math.random()
        .toString(36)
        .substring(3, 7)
        .toUpperCase()}`;
    public textColor: string;

    constructor(
        private readonly _service: DatiqGraphCardChartService,
        private _mapper: DatiqGraphCardChartMapperService,
    ) {}

    ngOnInit(): void {
        this.update();
    }

    update() {
        this.isPositive = this._service.isPositive(this.settings);
        this.isNegative = this._service.isNegative(this.settings);
        this.label = this._service.getLabel(this.settings);
        this.labelIcon = this._service.getPercentIcon(this.settings);
        this.textColor = this._service.getColor(this.settings);
        this.graph = this._mapper.mapGraph(this.settings);
    }
}
